import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/equipments',
    name: 'equipments',
    component: () => import('../views/Equipments.vue')
  },
  {
    path: '/categories',
    name: 'categories',
    component: () => import('../views/Categories.vue')
  },
  {
    path: '/profiles',
    name: 'profiles',
    component: () => import('../views/Profiles.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/Profile.vue')
  },
  {
    path: '/audit-logs',
    name: 'audit-logs',
    component: () => import('../views/AuditLogs.vue')
  },
  {
    path: '/borrows',
    name: 'borrows',
    component: () => import('../views/Borrows.vue')
  },
  {
    path: '/messages',
    name: 'messages',
    component: () => import('../views/Messages.vue')
  },
  {
    path: '/tasks',
    name: 'tasks',
    component: () => import('../views/Tasks.vue')
  },
  {
    path: '/approvals',
    name: 'approvals',
    component: () => import('../views/Approvals.vue')
  },
  {
    path: '/documents',
    name: 'documents',
    component: () => import('../views/Documents.vue')
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import('../views/Contacts.vue')
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import('../views/Calendar.vue')
  },
  {
    path: '/ai',
    name: 'ai',
    component: () => import('../views/AI.vue')
  },
  {
    path: '/business-config',
    name: 'business-config',
    component: () => import('../views/BusinessConfig.vue')
  },
  {
    path: '/lowcode/:code',
    name: 'lowcode-business',
    component: () => import('../views/LowCodeBusiness.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.onError((error) => {
  const isChunkLoadError = /loading chunk|failed to fetch dynamically imported module|Importing a module script failed/i.test(error?.message || '')
  if (!isChunkLoadError || sessionStorage.getItem('chunk-reload-attempted') === '1') return
  sessionStorage.setItem('chunk-reload-attempted', '1')
  window.location.reload()
})

// 路由守卫
router.beforeEach((to, from, next) => {
  sessionStorage.removeItem('chunk-reload-attempted')
  const user = localStorage.getItem('user')
  
  if (to.name !== 'login' && !user) {
    // 未登录且访问非登录页，跳转到登录页
    next({ name: 'login' })
  } else if (to.name === 'login' && user) {
    // 已登录且访问登录页，跳转到首页
    next({ name: 'home' })
  } else {
    next()
  }
})

export default router
